import NewTodo from "./components/NewTodo";
import Todos from "./components/Todos";

const App = () => {
  return (
    <div>
      <NewTodo />
      <Todos />
    </div>
  );
};

export default App;
